<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('detailEmplacement.info') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.natureSol')}}
        </p>
        <p class="has-text-default">
          {{ emplacementTechniqueInformation.natureSol }}
        </p>
      </div>
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.codeBarre')}}
        </p>
        <p class="has-text-default">
          {{ emplacementTechniqueInformation.codeBarre }}
        </p>
      </div>
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.degreDeniveleTerrain')}}
        </p>
        <p class="has-text-default">
          {{ emplacementTechniqueInformation.degreDeniveleTerrain }}
        </p>
      </div>
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.accesSiteSurRdv')}}
        </p>
        <p
          class="has-text-default">
          {{ emplacementTechniqueInformation.accesSiteSurRdv
          ? $t('general.oui') : $t('general.non')}}</p>
      </div>
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.acces')}}
        </p>
        <p class="has-text-default">
          {{ emplacementTechniqueInformation.acces }}
        </p>
      </div>
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.groupeDhabitation')}}
        </p>
        <p class="has-text-default">
          {{ emplacementTechniqueInformation.groupeDhabitation }}
        </p>
      </div>
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.numUg')}}
        </p>
        <p class="has-text-default">
          {{ emplacementTechniqueInformation.numUG }}
        </p>
      </div>
      <div class="column is-3">
        <p class="has-text-link has-text-weight-bold">
          {{$t('detailEmplacement.quartier')}}
        </p>
        <p class="has-text-default">
          {{ emplacementTechniqueInformation.quartier }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    emplacementTechniqueInformation: {
      type: Object,
      required: true,
    },
  },
};
</script>
